import { gql } from '@apollo/client';

export const GET_ACTIVITIES_CLASS_STUDENTS = gql`
  query GetActivitiesClassStudents($input: GetClassStudentsInput!) {
    getClassStudents(input: $input) {
      id
      email
      username
      firstName
      lastName
      emeji
    }
  }
`;
